// extracted by mini-css-extract-plugin
export default {"menuBox":"BigButton_menuBox__HrBlH","active":"BigButton_active__KlSVU","bg-danger":"BigButton_bg-danger__XewfA","mainText":"BigButton_mainText__sF8-R"};